import { render } from "./EditPolicy.vue?vue&type=template&id=58a47f27&scoped=true"
import script from "./EditPolicy.vue?vue&type=script&lang=js"
export * from "./EditPolicy.vue?vue&type=script&lang=js"

import "./EditPolicy.vue?vue&type=style&index=0&id=58a47f27&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a47f27"]])

export default __exports__